module.exports = __webpack_public_path__ + "img/无线温度传感器.f22729f8.jpg";